import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-5 pr-5 pb-5 overflow-auto h-screen" }

import GalleryContent from "@/views/camera/partials/GalleryContent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PublicGallery',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GalleryContent, { isPublic: true })
  ]))
}
}

})